import { cn } from "@newxsystems/shared";
import { StratosCommonContent } from "../../../../modules/content/components/StratosCommonContent/StratosCommonContent";
import { StratosMedia } from "../../../../modules/content/components/StratosMedia/StratosMedia";
import { StratosSection } from "../../../../modules/content/components/StratosSection/StratosSection";
import { VideoPlayer } from "../../../../modules/content/components/VideoPlayer/VideoPlayer";
import type { ITextMediaBlockProps } from "./TextMediaBlock.props";

export const TextMediaBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  direction,
  eyebrow,
  heading,
  image,
  parentClass,
  spacing,
  video,
}: ITextMediaBlockProps) => {
  const videoDestination =
    video?.source === "direct"
      ? video.directVideo
      : video?.source === "youtube"
        ? video.youtubeVideo
        : video?.source === "vimeo"
          ? video.vimeoVideo
          : undefined;
  const hasCopy = Boolean(eyebrow || heading || description || buttons?.length);
  if (!image && !videoDestination) return null;
  const media = (
    <div className="flex min-w-0 flex-col gap-4">
      {image ? (
        <StratosMedia
          aspectRatio={image.aspectRatio || "16:9"}
          media={image.image}
          sizes="(min-width: 768px) 50vw, 100vw"
        />
      ) : null}
      {video && videoDestination ? (
        <VideoPlayer
          banner={video.banner}
          directVideo={video.directVideo}
          source={video.source}
          vimeoVideo={video.vimeoVideo}
          youtubeVideo={video.youtubeVideo}
        />
      ) : null}
    </div>
  );
  return (
    <StratosSection className={parentClass} id={anchorId} spacing={spacing}>
      {hasCopy ? (
        <div className="grid items-center gap-8 overflow-hidden rounded-[20px] bg-mist p-5 md:grid-cols-2 md:gap-10 md:p-8 lg:gap-16 lg:p-12">
          <div
            className={cn(
              "order-1 flex min-w-0 items-center px-2 py-4 md:px-4",
              direction === "ltr" && "md:order-2",
            )}
          >
            <StratosCommonContent
              alignment={alignment}
              buttons={buttons}
              description={description}
              eyebrow={eyebrow}
              heading={heading}
            />
          </div>
          <div className={cn("order-2 min-w-0", direction === "ltr" && "md:order-1")}>{media}</div>
        </div>
      ) : (
        media
      )}
    </StratosSection>
  );
};

TextMediaBlock.displayName = "Block::TextMediaBlock";
